export default __webpack_public_path__ + "static/media/settings_selected.5cb15e56.svg";